import 'styled-components/macro';
import React from 'react';
import { Typography, useTheme } from '@harver/shared-ui';

import { ContentCard } from '../../components/ContentCard';
import { useContent } from '../../branding/content.context';

export function NoAvailableSlots() {
    const theme = useTheme();
    const { rescheduling } = useContent();

    const LANG = rescheduling.noAvailability;

    document.title = LANG.title;
    return (
        <>
            <ContentCard>
                <div
                    css={{
                        textAlign: 'center',
                        margin: `${theme.sizes.xxxLarge} 0`,
                    }}
                >
                    <Typography
                        css={{
                            textAlign: 'center',
                            marginBottom: theme.sizes.large,
                        }}
                        variant="h2"
                    >
                        {LANG.title}
                    </Typography>
                    <Typography
                        css={{
                            textAlign: 'center',
                        }}
                        variant="body2"
                    >
                        {LANG.message}
                    </Typography>
                </div>
            </ContentCard>
        </>
    );
}
